import type { InputHTMLAttributes, TextareaHTMLAttributes } from "react";

import { controlClassName } from "./controlClassName";
import { cn } from "./cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export function Input({ className, ...props }: InputProps) {
  return <input className={cn(controlClassName, className)} {...props} />;
}

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export function Textarea({ className, rows = 3, ...props }: TextareaProps) {
  return (
    <textarea
      rows={rows}
      className={cn(
        controlClassName,
        "h-auto min-h-24 py-3 leading-normal",
        className,
      )}
      {...props}
    />
  );
}
